export default "__VITE_ASSET__BNVmnoQW__"